import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useParams, Link as RouterLink, useNavigate } from 'react-router-dom';

import { crawlerApis } from '../../../apis/crawlerApis';
import Loading from '../../../components/elements/loading/Loading';
import CrawlerJobDetails from '../../../components/page-sections/web-crawler/crawler-details/CrawlerJobDetails';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import TitlePanel from '../../../components/sections/title-panel/TitlePanel';
import { handleErrors } from '../../../helpers';
import useToast from '../../../hooks/useToast';
import { buildPath, PRIVATE_ROUTE } from '../../../routes/routes';

const ProjectCrawlerDetailsPage = () => {
  const { projectId, crawlerJobId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [crawlJob, setCrawlJob] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const crawlJobRes = await crawlerApis.getCrawlJob(
        projectId,
        crawlerJobId
      );
      const foundJob = crawlJobRes?.data;

      if (foundJob) {
        setCrawlJob(foundJob);
      } else {
        return navigate(PRIVATE_ROUTE.ERROR404, { replace: true });
      }
    } catch (error) {
      handleErrors(navigate, error, showToast);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!projectId) return;
    fetchData();
  }, [projectId, crawlerJobId]);

  return loading ? (
    <Loading />
  ) : (
    <Container>
      <Breadcrumbs jobName={crawlJob.name} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <TitlePanel
          visible
          title={t('crawler.details', { ns: 'sectionTitles' })}
        />
        <Button
          variant="text"
          component={RouterLink}
          to={buildPath({
            path: PRIVATE_ROUTE.PROJECT_CRAWLER,
            params: { projectId },
          })}
        >
          {t('returnToJobOverview', { ns: 'buttons' })}
        </Button>
      </Box>
      <Box>
        <CrawlerJobDetails job={crawlJob} />
      </Box>
    </Container>
  );
};

export default ProjectCrawlerDetailsPage;
